<template>
  <div class="status-container " :class="cssClass">
    <span class="status-container--text text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    status: null,
  },

  computed: {
    text() {
      switch (this.status) {
        case 1:
          return this.$t('approve.accepted');
        case 2:
          return this.$t('approve.rejected');
        default:
          return this.$t('approve.pending')
      }
    },

    cssClass() {
      switch (this.status) {
        case 1:
          return 'green';
        case 2:
          return 'red';
        default:
          return 'yellow'
      }
    },


  }
}
</script>

